module.exports = __webpack_public_path__ + "img/recruiment.bf1b851c.svg";